<template>
  <DialogHeader>
    <template #left>
      <div class="cursor-pointer" @click="close()">Cancel</div>
    </template>
    Deactivate instead?
  </DialogHeader>
  <DialogContent>
    <div class="flex flex-col">
      <Avatar
        :src="userStore.user?.avatarUrl"
        :size="60"
        class="mb-2 self-center"
      />
      <div
        class="max-w-[344px] font-primary font-semibold text-[23px] leading-[28px] text-gray-800 text-center self-center mb-[34px]"
      >
        Deactivate your account instead of deleting?
      </div>
      <div>
        <div class="flex mb-[34px]">
          <Icon :size="34" name="Hidden" class="stroke-gray-800 mr-5" />
          <div class="text-[14px]">
            <div class="font-primary font-semibold mb-2">
              Deactivating your account is temporary
            </div>
            <div class="font-secondary text-gray-500">
              Your account will be deactivated until you enable it by logging
              back in. Please be aware your account balance will still accrue
              while your account is deactivated and full payment will be
              required to restore your services.
            </div>
          </div>
        </div>
        <div class="flex">
          <Icon :size="34" name="Alert" class="stroke-gray-800 mr-5" />
          <div class="text-[14px] -mt-1">
            <div class="font-primary font-semibold mb-2">
              Deleting your account is permanent
            </div>
            <div class="font-secondary text-gray-500">
              Deleting your account will permanently delete your account info
              but will not remove your info from any copyrighted work that has
              been added or from any past transactions.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-6">
      <UiButton class="w-full! mb-2" danger @click="handleDeactivateClick">
        Deactivate account
      </UiButton>
      <div
        class="text-center font-primary font-medium text-[16px] leading-[22px] text-red-700 cursor-pointer"
        @click="handleDeleteClick"
      >
        Delete account
      </div>
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import { UiButton, Icon, Avatar } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'

import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import { useUserStore } from '@/shared/stores/user'

const { close, open } = useDialog()
const userStore = useUserStore()

const handleDeleteClick = () => {
  open(Dialogs.DeleteAccount)
}

const handleDeactivateClick = () => {
  open(Dialogs.DeactivateAccount)
}
</script>
